import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var EarthLocationSvg = function EarthLocationSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.093 7.65V6.323h1.338V7.65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m17.762 13.354-.403-.3-.003-.002-.01-.008-.034-.026-.122-.096a14.595 14.595 0 0 1-1.712-1.618c-.908-1.014-1.953-2.505-1.953-4.096 0-1.117.446-2.187 1.24-2.976a4.25 4.25 0 0 1 2.997-1.233c1.124 0 2.202.444 2.997 1.233A4.2 4.2 0 0 1 22 7.208c0 1.591-1.046 3.082-1.953 4.096a14.6 14.6 0 0 1-1.835 1.714l-.034.026-.01.008-.002.002h-.002zm0-9.026a2.9 2.9 0 0 0-2.05.844 2.87 2.87 0 0 0-.85 2.036c0 1.066.74 2.233 1.616 3.213a13 13 0 0 0 1.284 1.246l.117-.1c.32-.278.745-.674 1.168-1.146.876-.98 1.615-2.147 1.615-3.213a2.87 2.87 0 0 0-.85-2.036 2.9 2.9 0 0 0-2.05-.844",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.41 5.461a7.5 7.5 0 0 1 3.126.07l.31-1.293A8.87 8.87 0 0 0 5.762 5.58a8.8 8.8 0 0 0-2.513 2.68 8.7 8.7 0 0 0-.844 7.113 8.7 8.7 0 0 0 1.818 3.186 8.8 8.8 0 0 0 2.97 2.17 8.9 8.9 0 0 0 3.607.77c4.245 0 7.787-2.98 8.623-6.95l-1.31-.272a7 7 0 0 1-.11.45H11.51v2.67l1.543 2.43a7.52 7.52 0 0 1-5.31-.31 7.47 7.47 0 0 1-3.318-2.914h3.272v-4.947h4.096v-1.33H6.359v4.948H3.784a7.4 7.4 0 0 1-.395-3.392 7.4 7.4 0 0 1 1.008-2.94 7.4 7.4 0 0 1 2.131-2.273A7.5 7.5 0 0 1 9.41 5.46m4.894 13.844a7.48 7.48 0 0 0 3.187-3.25h-4.643v.958z",
    clipRule: "evenodd"
  }));
};
export var EarthLocation = function EarthLocation(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: EarthLocationSvg
  }));
};